import { render, staticRenderFns } from "./EnableNotifications.vue?vue&type=template&id=799250d6&scoped=true"
import script from "./EnableNotifications.vue?vue&type=script&lang=js"
export * from "./EnableNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799250d6",
  null
  
)

export default component.exports